// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorLongResponse {
    static getAttributeTypeMap() {
        return PayorLongResponse.attributeTypeMap;
    }
}
PayorLongResponse.discriminator = undefined;
PayorLongResponse.additionalProperties = false;
PayorLongResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=payorLongResponse.js.map